import { useFocusEffect } from '@react-navigation/native';
import { useCallback } from 'react';
import { Platform } from 'react-native';
import { AvoidSoftInput } from 'react-native-avoid-softinput';

/**
 * On Android, sets windowSoftInputMode to adjustPan when the checkout screen
 * has focus so the window pans instead of resizing. That prevents the ScrollView
 * from changing height and resetting scroll position when the keyboard opens.
 * Restores default (setEnabled(false)) when the screen loses focus (e.g. user
 * navigates to delivery-terms or another pushed route). Tied to focus/blur so
 * the mode does not leak into other screens while checkout stays mounted in the stack.
 * No-op on iOS.
 */
export function useCheckoutAndroidKeyboardMode() {
  useFocusEffect(
    useCallback(() => {
      if (Platform.OS !== 'android') return;

      AvoidSoftInput.setEnabled(true);
      AvoidSoftInput.setAdjustPan();

      return () => {
        AvoidSoftInput.setEnabled(false);
      };
    }, [])
  );
}
